import React, { useEffect, useState } from "react";
import TitleComp from "./titleComp";
import EmployeeListTable from "./employeeListTable";
import CrossIcon from "../../assets/images/search-clear.svg";
import DebounceInput from "react-debounce-input";
import { toast } from "react-toastify";
import { autocloseTiming } from "../../api/regex";
import { postData } from "../../api";
import Loader from "../Loader";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";

export default function EmployeeListComp() {
  const [employeeList, setEmployeeList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState({
    userId: null,
    gusto_emp_uuid: null,
  });
  const [loading, setLoading] = useState(false);
  const [flowUrl] = useState(null);
  const [warningModal, setWarningModal] = useState({
    visible: false,
    message: "",
  });
  const navigate = useNavigate();

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearchValue("");
  };

  const filteredData = employeeList.filter((employee) => {
    return employee.name.toLowerCase().includes(searchValue.toLowerCase());
  });

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(0);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = filteredData.slice(
    currentPage * rowsPerPage,
    (currentPage + 1) * rowsPerPage
  );
  const handleEmployeeSelection = (data) => {
    setSelectedEmployee((prev) => ({
      ...prev,
      userId: data.id,
      gusto_emp_uuid: data.gusto_emp_uuid,
    }));
  };
  const groupIdToRole = {
    1: "Super Admin",
    2: "System Admin",
    3: "Client Admin",
    4: "Manager",
    5: "Employee",
  };

  const getEmployeeList = async () => {
    setLoading(true);
    try {
      const res = await postData("user_list", {}, {});
      if (res.status === true) {
        setLoading(false);
        const transformedData = res.data.map((employee) => ({
          ...employee,
          name: employee.full_name,
          role: groupIdToRole[employee.group_id] || "Unknown",
        }));
        setEmployeeList(transformedData);
      } else if (res.message === "Company onboarding is pending") {
        setLoading(false);
        setWarningModal({
          visible: true,
          message: res.message,
        });
      } else {
        setLoading(false);
        toast.error(res.message, {
          theme: "colored",
          autoClose: autocloseTiming,
        });
      }
    } catch (err) {
      setLoading(false);
      toast.error(err, {
        theme: "colored",
        autoClose: autocloseTiming,
      });
    }
  };

  useEffect(() => {
    getEmployeeList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreateFlow = () => {
    navigate("/iframe?type=deductions&from=employee-list", {
      state: { selectedEmployee },
    });
  };
  const handleRedirection = () => {
    window.history.go(-1);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="mx-0 mx-sm-3 mx-md-3">
          <div>
            <TitleComp
              selectedEmployee={selectedEmployee}
              handleCreateFlow={handleCreateFlow}
              flowUrl={flowUrl}
            />
          </div>
          <>
            <div className="employee-list-main-wrapper">
              <h5>Select the Employee from the list ({filteredData.length})</h5>
              <div className="d-flex deduction-input-wrapper">
                <div className="input-group">
                  <DebounceInput
                    type="text"
                    placeholder="Search"
                    value={searchValue}
                    onChange={handleSearchChange}
                    debounceTimeout={500}
                  />
                  {searchValue && (
                    <img
                      src={CrossIcon}
                      alt="Clear"
                      className="clear-icon"
                      onClick={clearSearch}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="deduction-table-wrapper">
              <EmployeeListTable
                paginatedData={paginatedData}
                rowsPerPage={rowsPerPage}
                currentPage={currentPage}
                totalPages={totalPages}
                handleRowsPerPageChange={handleRowsPerPageChange}
                handlePageChange={handlePageChange}
                handleEmployeeSelection={handleEmployeeSelection}
                employeeList={employeeList}
                selectedEmployee={selectedEmployee}
              />
            </div>
          </>
        </div>
      )}
      <Modal
        show={warningModal.visible}
        backdrop="static"
        keyboard={false}
        className="warning-non-close-modal"
      >
        {" "}
        <Modal.Header>Finish Company Onboarding</Modal.Header>
        <Modal.Body>
          You’ll be able to set up Deductions once your company onboarding is
          complete. Please complete the onboarding process to continue.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleRedirection}
            className="modal-btn-wrapper modal-email-footer-button"
          >
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
